import { useState, useEffect } from "react";
import { singletonHook } from "react-singleton-hook";

// const [useMyData, updateMyData] = createSingleton({});

const init = {
  // loading: true,
  fontSize: 100,
  setFontSize: () => {},
};

const useFontSettingsHook = () => {
  const [fontSize, setFontSizeInternal] = useState([]);
  // const [loading, setLoading] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem('parserFontSize');
    setFontSizeInternal(stored !== null ? parseInt(stored, 10): 110);
  }, []);

  const setFontSize = (input) => {
    if (typeof input !== 'number') return
    input = fontSize + input
    if (input < 90) input = 90
    if (input > 200) input = 200

    localStorage.setItem('parserFontSize', `${input}`)
    setFontSizeInternal(input)
  }

  return {
    fontSize,
    setFontSize,
    // loading,
  };
};

const useFontSize = singletonHook(init, useFontSettingsHook);

export default useFontSize;
